import { render, staticRenderFns } from "./SimpleView.vue?vue&type=template&id=79a70414&"
import script from "./SimpleView.vue?vue&type=script&lang=js&"
export * from "./SimpleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports